<template>
  <div v-if="object">
    <div class="row">
      <div class="col-md-8">

        <ServiceMultiSelect :label="$t('classificator_title')"
                            :dblclick="false"
                            :multiple="false"
                            model="russian_classificator_service"
                            title="title"
                            :dbsearch="true"
                            @input="classificatorChanged"
                            v-model="object.russian_classificator_service"/>

      </div>
      <div class="col-md-4">
        <InputGroup :readonly="true"
                    :value="code"
                    :label="$t('classificator_code')"/>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue"
//
import ServiceMultiSelect from "@/components/form/ServiceMultiSelect.vue"
import InputGroup from "@/components/form/InputGroup.vue"

const props = defineProps({
  object: {
    type: Object
  },
  options: {},
})

const code = ref('')

const classificatorChanged = (val) => {
  props.object.classificator_id = val ? val.id : ''
  code.value = val ? val.code : ''
}
</script>
